import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "stafflist",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(
          /* webpackChunkName: "stafflist" */ "SchoolSetup/modules/SchoolSetupModule"
        ),
        import(
          /* webpackChunkName: "stafflist" */ "TeacherSetup/modules/Module"
        ),
        import(/* webpackChunkName: "stafflist" */ "./components"),
        import(
          /* webpackChunkName: "stafflist" */ "SchoolSetup/modules/StaffEnrollModalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const schoolSetupReducer = importedModule0.default;
          const teacherSetupModule = importedModule1;
          const component = importedModule2.default;
          const staffEnrollModalModule = importedModule3.default;
          injectReducer(store, {
            key: "schoolSetup",
            reducer: schoolSetupReducer,
          });
          const reducer = teacherSetupModule.default;
          const key = teacherSetupModule.NAME;
          injectReducer(store, {
            key,
            reducer,
          });
          injectReducer(store, {
            key: "staffEnrollModal",
            reducer: staffEnrollModalModule,
          });
          return component;
        }
      );
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
